import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const InventoryAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		itemname: yup.string().required().label("Itemname"),
		category: yup.string().nullable().label("Category"),
		quantity: yup.number().required().label("Quantity"),
		unit: yup.string().nullable().label("Unit"),
		minimumstocklevel: yup.number().nullable().label("Minimumstocklevel"),
		reorderlevel: yup.number().nullable().label("Reorderlevel"),
		unitcost: yup.number().nullable().label("Unitcost"),
		supplier: yup.string().nullable().label("Supplier"),
		lastrestocked: yup.string().nullable().label("Lastrestocked"),
		nextrestockdate: yup.string().nullable().label("Nextrestockdate"),
		status: yup.string().nullable().label("Status"),
		createdat: yup.string().nullable().label("Createdat")
	});
	
	//form default values
	const formDefaultValues = {
		itemname: '', 
		category: '', 
		quantity: '', 
		unit: '', 
		minimumstocklevel: '', 
		reorderlevel: '', 
		unitcost: '', 
		supplier: '', 
		lastrestocked: new Date(), 
		nextrestockdate: new Date(), 
		status: "InStock", 
		createdat: "(getdate())", 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/inventory`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="InventoryAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Inventory"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Itemname *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="itemname"  onChange={formik.handleChange}  value={formik.values.itemname}   label="Itemname" type="text" placeholder="Enter Itemname"        className={inputClassName(formik?.errors?.itemname)} />
                                                <ErrorMessage name="itemname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Category 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="category"  onChange={formik.handleChange}  value={formik.values.category}   label="Category" type="text" placeholder="Enter Category"        className={inputClassName(formik?.errors?.category)} />
                                                <ErrorMessage name="category" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Quantity *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="quantity"  onChange={formik.handleChange}  value={formik.values.quantity}   label="Quantity" type="number" placeholder="Enter Quantity"  min={0}  step="any"    className={inputClassName(formik?.errors?.quantity)} />
                                                <ErrorMessage name="quantity" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Unit 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="unit"  onChange={formik.handleChange}  value={formik.values.unit}   label="Unit" type="text" placeholder="Enter Unit"        className={inputClassName(formik?.errors?.unit)} />
                                                <ErrorMessage name="unit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Minimumstocklevel 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="minimumstocklevel"  onChange={formik.handleChange}  value={formik.values.minimumstocklevel}   label="Minimumstocklevel" type="number" placeholder="Enter Minimumstocklevel"  min={0}  step="any"    className={inputClassName(formik?.errors?.minimumstocklevel)} />
                                                <ErrorMessage name="minimumstocklevel" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Reorderlevel 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="reorderlevel"  onChange={formik.handleChange}  value={formik.values.reorderlevel}   label="Reorderlevel" type="number" placeholder="Enter Reorderlevel"  min={0}  step="any"    className={inputClassName(formik?.errors?.reorderlevel)} />
                                                <ErrorMessage name="reorderlevel" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Unitcost 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="unitcost"  onChange={formik.handleChange}  value={formik.values.unitcost}   label="Unitcost" type="number" placeholder="Enter Unitcost"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.unitcost)} />
                                                <ErrorMessage name="unitcost" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Supplier 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="supplier"  onChange={formik.handleChange}  value={formik.values.supplier}   label="Supplier" type="text" placeholder="Enter Supplier"        className={inputClassName(formik?.errors?.supplier)} />
                                                <ErrorMessage name="supplier" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Lastrestocked 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="lastrestocked" showButtonBar className={inputClassName(formik?.errors?.lastrestocked)} dateFormat="yy-mm-dd" value={formik.values.lastrestocked} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="lastrestocked" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Nextrestockdate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="nextrestockdate" showButtonBar className={inputClassName(formik?.errors?.nextrestockdate)} dateFormat="yy-mm-dd" value={formik.values.nextrestockdate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="nextrestockdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Status 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="status"  onChange={formik.handleChange}  value={formik.values.status}   label="Status" type="text" placeholder="Enter Status"        className={inputClassName(formik?.errors?.status)} />
                                                <ErrorMessage name="status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
InventoryAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'inventory',
	apiPath: 'inventory/add',
	routeName: 'inventoryadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default InventoryAddPage;
